export default "__VITE_ASSET__BWiJ$OP1__"